export const CURRENT_SEASON_YEAR = '2025';
